import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MediaService } from './media.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpecialisatieService {

  constructor(private http:HttpClient, private mediaService:MediaService) { }

  getSpecialisaties() {
    return this.http.get<any>(`${environment.apiBaseUrl}/specialisaties?populate=*&sort[1]=order`);
  }

  getSpecialisatie(id:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/specialisaties?filters[id][$eq]=${id}&populate=*`);
  }

  getSpecialisatiesFor(discid:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/specialisaties?filters[disciplines][id][$eq]=${discid}&populate=*&sort[1]=order`);
  }

  populateSpecialisatie(data:any) {
    let spec = data;
    spec.id = data.id;
    spec.pic = this.mediaService.getMediaItemUrl(spec.afbeelding);
    spec.banner_image = this.mediaService.getMediaItemUrl(spec.banner_image, null);
    return spec;
  }
}
